export default __webpack_public_path__ + "static/media/simplify_logoC.d8250853.png";